<template>
  <div class="h-full">
    <!-- Displays all the choices that have been selected for the entire module (i.e. Components, Drivetrain) -->
    <project-one-right-rail-base-selections
      v-if="isRootModuleGroups"
      :base-properties="baseProperties"
      qaid="rail-theme-scroll-list"
    />

    <!-- Displays the choices within the personalization section -->
    <project-one-right-rail-personalization-choices
      v-else-if="$route.name === 'personalize'"
      :base-properties="baseProperties"
      qaid="rail-theme-scroll-list"
    />

    <!-- Displays the choices within a single component (i.e. Wheels, Handlebars) -->
    <project-one-right-rail-choice-list
      v-else-if="isPresentationType('CMP_LIST')"
      :base-properties="baseProperties"
      :is-single-level-list="isSingleLevelList"
      :select-item-module="selectItemModule"
      qaid="rail-theme-scroll-list"
    />

    <!-- Displays the choices for size based components (i.e. cranks, chainrings) -->
    <project-one-right-rail-sizes
      v-else-if="isPresentationType('SZE_LIST')"
      :base-properties="baseProperties"
      qaid="rail-theme-scroll-list"
    />

    <!-- Displays the detailed view (image/description) of a single component (i.e. Aeolus Pro 3V TLR ) -->
    <project-one-right-rail-list-item
      v-else-if="isPresentationType('CMP_LIST_ITEM')"
      :base-properties="baseProperties"
      qaid="rail-theme-scroll-list"
    />

    <!-- Displays the color selection view -->
    <project-one-right-rail-swatches
      v-else-if="isPresentationType('CLR_SWATCH')"
      :base-properties="baseProperties"
      qaid="rail-theme-scroll-list"
    />
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import ProjectOneRightRailBaseSelections from '@/projectOne/components/rightRail/surfaces/ProjectOneRightRailBaseSelections';
import ProjectOneRightRailChoiceList from '@/projectOne/components/rightRail/surfaces/ProjectOneRightRailChoiceList';
import ProjectOneRightRailListItem from '@/projectOne/components/rightRail/surfaces/ProjectOneRightRailListItem';
import ProjectOneRightRailSizes from '@/projectOne/components/rightRail/surfaces/ProjectOneRightRailSizes';
import ProjectOneRightRailSwatches from '@/projectOne/components/rightRail/surfaces/ProjectOneRightRailSwatches';
import ProjectOneRightRailPersonalizationChoices from '@/projectOne/components/rightRail/surfaces/ProjectOneRightRailPersonalizationChoices';

export default {
  components: {
    ProjectOneRightRailBaseSelections,
    ProjectOneRightRailChoiceList,
    ProjectOneRightRailListItem,
    ProjectOneRightRailSizes,
    ProjectOneRightRailSwatches,
    ProjectOneRightRailPersonalizationChoices,
  },

  computed: {
    isSectionPaintTheme() {
      return this.$route.name === 'paintTheme';
    },

    isRootModuleGroups() {
      return this.activeRailData?.content?.isRootModuleGroups ?? false;
    },

    // A single level list is a list in which you can select options directly on it as opposed
    // to going into a detail item view and clicking [+ Add to Bike] from there.
    isSingleLevelList() {
      // Currently the only list that does this is the headbadge list in the paint and theme module.
      // This method can be modified in the future to allow additional business logic to enable single level lists.
      return this.isSectionPaintTheme;
    },

    // Specificies the module that should be used when posting component updates to the API
    selectItemModule() {
      return this.isSectionPaintTheme ? 'paint-scheme' : null;
    },

    ...mapGetters('projectOne', ['activeRailData']),
  },

  methods: {
    isPresentationType(presentationType) {
      return this.activeRailData?.content?.presentationType === presentationType;
    },
  },
};
</script>

<style lang="scss">
// This style thing is purposely not 'scoped' so that the styles trickle down to the surface component children
.project-one-right-rail {
  display: grid;
  grid-template-rows: auto 1fr auto;
  height: 100%;
}

.project-one-right-rail__body {
  @apply px-2;

  @screen lg {
    @apply pr-2;
    @apply pl-4;

    overflow-y: scroll;

    &::-webkit-scrollbar {
      width: 1rem;
    }

    &::-webkit-scrollbar-thumb {
      background-clip: content-box;
      background-color: var(--gray-20);
      border: 0.25rem solid transparent;
      border-radius: 0.5rem;
    }
  }
}
</style>
